import { render, staticRenderFns } from "./UserRoleBulkAddDialog.vue?vue&type=template&id=072feee4&scoped=true"
import script from "./UserRoleBulkAddDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleBulkAddDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleBulkAddDialog.vue?vue&type=style&index=0&id=072feee4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072feee4",
  null
  
)

export default component.exports